// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"638d4617","453":"3c2f4772","624":"83311b2d","850":"3b52ffe3"}[chunkId] + ".chunk.js";
};